import React from 'react';
import { Table } from 'react-bootstrap';
import { isIterableArray } from '../../helpers/utils';

const table = (props: any) => {
  return (
    <Table bordered className="spec-container">
      <tbody>
        {isIterableArray(props.data) &&
          props.data.map((item: any, i: number) => {
            return (
              <React.Fragment key={i}>
                <tr>
                  <td>{item.Label}</td>
                  <td>{item.Value}</td>
                </tr>
                {props.data.length - 1 === i && props.note && (
                  <tr>
                    <td colSpan={2}>{props.note}</td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
      </tbody>
    </Table>
  );
};

export default table;
